const PRODUCTS_PRICE = 500;
const PRODUCTS_PRICE_PER_HOUR = 100;

const calculatePricing = (
  address,
  duration,
  shouldIncludeProducts = false,
  productsPricing = null
) => {
  const { price, price_per_hour, fee, fee_per_hour } = address.district.pricing;

  const professional =
    price +
    (shouldIncludeProducts ? productsPricing.price : 0) +
    duration *
      (price_per_hour +
        (shouldIncludeProducts ? productsPricing.price_per_hour : 0));

  const dnm =
    fee +
    (shouldIncludeProducts ? productsPricing.fee : 0) +
    duration *
      (fee_per_hour +
        (shouldIncludeProducts ? productsPricing.fee_per_hour : 0));

  return professional + dnm;
};

export default {
  calculatePricing
};



// WEBPACK FOOTER //
// ./src/utils/helpers/pricingHelper.js